import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { NewLandingPage } from "./pages/NewLandingPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NewLandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
